import AnimatedNumber from './AnimatedNumber';

export default AnimatedNumber;